import apiUrl from "./config/config";
import axios from "axios";

class processLogApi
{

  //Get a processlog 
  static async getProcessLog(id)
  {

    try
    {

      const response = await axios(apiUrl + `processlog/${id}`);

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }

  //Get all processlogs
  static async getProcessLogs(params = {})
  {

    try
    {

      const response = await axios(apiUrl + "processlog", { params });

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }


  //Update a processlog
  static async updateProcessLog(params)
  {

    try
    {

      const response = await axios.post(apiUrl + "processlog", params);

      return response.data;

    } catch (err)
    {

      throw new Error(err);

    }

  }

  //Update a processlog review
  static async updateProcessLogReview(params)
  {

    try
    {

      const response = await axios.post(apiUrl + "processlog/review", params);

      return response.data;

    } catch (err)
    {

      throw new Error(err);

    }

  }

  //Update a processlog tech
  static async updateProcessLogContacted(params)
  {

    try
    {

      const response = await axios.post(apiUrl + "processlog/contacted", params);

      return response.data;

    } catch (err)
    {

      throw new Error(err);

    }

  }

  //Delete a processlog
  static async deleteProcessLog(id)
  {

    try
    {

      const response = await axios.delete(apiUrl + `processlog/${id}`);

      return response.data;

    } catch (err)
    {

      throw new Error(err);

    }

  }

  //Get a processlog by serial number
  static async getProcessLogBySerialNumber(code)
  {

    try
    {

      const response = await axios(apiUrl + `processlog/serial/${code}`);

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }

}

export default processLogApi;
